import { parseInitialValues as parseInitialInfoValues, formValues as formValuesInfo } from './EntranceInfo/EntranceInfo.selectors';
import { parseInitialValues as parseInitialUnlocValues, formValues as formValuesUnloc } from './EntranceUnloc/EntranceUnloc.selectors';
import { parseInitialValues as parseInitialInletValues, formValues as formValuesInlet } from './EntranceInlet/EntranceInlet.selectors';

export const getPrioritizedEntrance = location => !!location.entrances && !!location.entrances.length && (location.entrances.find(({attributes:{ type }}) => type === 'lock') || location.entrances.find(({attributes:{ type }}) => type === 'info') || location.entrances[0]);

export const getCurrentEntrance = (location, entranceType) => {
  if (!location.entrances || !location.entrances.length) {
    return null;
  }
  if (entranceType === 'info') {
    return location.entrances.find(({attributes:{ type }}) => type === 'info');
  }
  return location.entrances.find(({attributes}) =>
    attributes.type === 'lock'
    && attributes.config
    && attributes.config.provider === entranceType
  );
};

export const getEntranceType = entrance => entrance && entrance.attributes.type === 'lock' && entrance.attributes.config ? entrance.attributes.config.provider : entrance ? entrance.attributes.type : null;

export const parseInitialValues = entrance => ({
  ...parseInitialInfoValues(entrance),
  ...parseInitialUnlocValues(entrance),
  ...parseInitialInletValues(entrance),
});

export const formFields = [
  ...formValuesInfo,
  ...formValuesUnloc,
  ...formValuesInlet,
];
